// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorui {
  justify-content: center;
  align-items: center;
  margin-top: 16%;
}
.errornum h1 {
  position: absolute;
  font-size: 253px;
  opacity: 0.23;
  margin-left: 34%;
  margin-top: -85px;
}
.errorui h3 {
  font-size: 85px;
}
.errorui h5 {
  font-size: 30px;
  width: 100vw;
  justify-content: center;
  align-items: center;
  margin: 5px;
}
.errorui button {
  border: none;
  border-radius: 4px;
  font-size: 22px;
  padding: 7px 17px;
  background-color: #68ad3f;
  color: #ffffff;
  font-family: Rubik;
  font-weight: 500;
  border: 2px solid #68ad3f;
  margin: auto;
}
.errorui button:hover {
  background: #fbb040;
  color: #ffffff;
  border: 2px solid #fbb040;
}
.errornum h1 {
  position: absolute;
  font-size: 340px !important;
  opacity: 0.23;
  margin: unset;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.errorContent {
  margin: unset;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

@media (max-width: 601px) and (max-width: 700px) {
  .errornum h1 {
    position: absolute;
    font-size: 50vw !important;
    opacity: 0.23;
    margin: unset;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@media screen and (max-width: 600px) {
  .errorui h5 {
    font-size: 15px;
    width: 100vw;
    justify-content: center;
    align-items: center;
    margin: 5px;
  }
  .errorui button {
    border: none;
    border-radius: 4px;
    font-size: 15px;
    padding: 7px 17px;
    background-color: #68ad3f;
    color: #ffffff;
    font-family: Rubik;
    font-weight: 500;
    border: 2px solid #68ad3f;
    margin: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Errors/pagenotfound.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;EACd;AACF","sourcesContent":[".errorui {\n  justify-content: center;\n  align-items: center;\n  margin-top: 16%;\n}\n.errornum h1 {\n  position: absolute;\n  font-size: 253px;\n  opacity: 0.23;\n  margin-left: 34%;\n  margin-top: -85px;\n}\n.errorui h3 {\n  font-size: 85px;\n}\n.errorui h5 {\n  font-size: 30px;\n  width: 100vw;\n  justify-content: center;\n  align-items: center;\n  margin: 5px;\n}\n.errorui button {\n  border: none;\n  border-radius: 4px;\n  font-size: 22px;\n  padding: 7px 17px;\n  background-color: #68ad3f;\n  color: #ffffff;\n  font-family: Rubik;\n  font-weight: 500;\n  border: 2px solid #68ad3f;\n  margin: auto;\n}\n.errorui button:hover {\n  background: #fbb040;\n  color: #ffffff;\n  border: 2px solid #fbb040;\n}\n.errornum h1 {\n  position: absolute;\n  font-size: 340px !important;\n  opacity: 0.23;\n  margin: unset;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.errorContent {\n  margin: unset;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  position: absolute;\n}\n\n@media (max-width: 601px) and (max-width: 700px) {\n  .errornum h1 {\n    position: absolute;\n    font-size: 50vw !important;\n    opacity: 0.23;\n    margin: unset;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .errorui h5 {\n    font-size: 15px;\n    width: 100vw;\n    justify-content: center;\n    align-items: center;\n    margin: 5px;\n  }\n  .errorui button {\n    border: none;\n    border-radius: 4px;\n    font-size: 15px;\n    padding: 7px 17px;\n    background-color: #68ad3f;\n    color: #ffffff;\n    font-family: Rubik;\n    font-weight: 500;\n    border: 2px solid #68ad3f;\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
